import { render, staticRenderFns } from "./NordStartPage.vue?vue&type=template&id=8d952662&"
import script from "./NordStartPage.vue?vue&type=script&lang=js&"
export * from "./NordStartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d952662')) {
      api.createRecord('8d952662', component.options)
    } else {
      api.reload('8d952662', component.options)
    }
    module.hot.accept("./NordStartPage.vue?vue&type=template&id=8d952662&", function () {
      api.rerender('8d952662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordStartPage.vue"
export default component.exports